import { uiCoreI18nSource } from '@tencent/ui-core';
import { wujiComponentBaseI18nSource } from '@tencent/wuji-component-base/i18n';
// @ts-ignore
import { messages as i18nSource } from '@tencent/wuji-source/lib/i18n/index';
import { enMerged } from './en';
import { zh } from './zh';
import VueI18n from 'vue-i18n';
import Vue from 'vue';
import { Lang } from './lang';
import { CustomFormatter } from './formatter';
import { isPlainObject, isString } from 'lodash';
import { IS_DEV } from '@/workbench/common/env';
const zhWithDefault = Object.keys(zh).length
    ? zh
    : Object.assign({}, Object.keys(enMerged).reduce((obj, key) => {
        Object.assign(obj, { [key]: key });
        return obj;
    }, {}), zh);
const i18nData = window.xy_runtime_i18n_data;
const PLATFORM_LANG_SOURCE = [];
// xy和wuji_source的词条有可能会重复
const platformHashSet = new Set();
const initSource = (hashMap) => {
    Object.entries(hashMap).forEach(([hash, originContent]) => {
        const zhKey = originContent;
        if (platformHashSet.has(hash)) {
            return;
        }
        platformHashSet.add(hash);
        const key = IS_DEV ? zhKey : hash;
        PLATFORM_LANG_SOURCE.push({
            hash,
            content: zhKey,
            [Lang.Chinese]: zhWithDefault[key],
            [Lang.English]: enMerged[key],
        });
    });
    // 添加 wuji-component-base 的词条
    const zhTranslation = wujiComponentBaseI18nSource[Lang.Chinese];
    const enTranslation = wujiComponentBaseI18nSource[Lang.English];
    Object.entries(zhTranslation).forEach(([hash, content]) => {
        if (platformHashSet.has(hash)) {
            return;
        }
        platformHashSet.add(hash);
        PLATFORM_LANG_SOURCE.push({
            hash,
            content,
            [Lang.Chinese]: content,
            [Lang.English]: enTranslation[hash],
        });
    });
};
const platformHashMap = {};
// DEV 环境下平台内置词条的key是中文，需要转换直出的译文key为中文
if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const json = require('../../i18n-output/hashMap.json');
    Object.assign(platformHashMap, json);
    if (isPlainObject(json)) {
        initSource(json);
    }
}
else {
    initSource(zhWithDefault);
}
const messages = {
    [Lang.English]: { ...enMerged, ...uiCoreI18nSource?.[Lang.English], ...wujiComponentBaseI18nSource?.[Lang.English], ...i18nSource?.[Lang.English] },
    [Lang.Chinese]: { ...zhWithDefault, ...platformHashMap, ...uiCoreI18nSource?.[Lang.Chinese], ...wujiComponentBaseI18nSource?.[Lang.Chinese], ...i18nSource?.[Lang.Chinese] },
};
const lang = window.langController.getLang();
const fallbackLang = i18nData?.enabled ? (i18nData?.fallbackLang || Lang.Chinese) : Lang.Chinese;
if (fallbackLang && fallbackLang !== lang) {
    messages[fallbackLang] = {
        ...messages[Lang.Chinese],
        ...messages[fallbackLang],
    };
}
if (i18nSource) {
    window.provideWujiSourceI18n = true;
    const trans = Object.values(i18nSource)[0];
    Object.keys(trans).forEach((hash) => {
        const content = i18nSource[Lang.Chinese][hash];
        if (!content) {
            return;
        }
        if (platformHashSet.has(hash)) {
            return;
        }
        platformHashSet.add(hash);
        PLATFORM_LANG_SOURCE.push({
            hash,
            content,
            [Lang.Chinese]: i18nSource[Lang.Chinese][hash],
            [Lang.English]: i18nSource[Lang.English][hash],
        });
    });
}
if (i18nData?.lang) {
    messages[i18nData.lang] = {
        ...messages[i18nData.lang],
        ...Object.fromEntries(Object.entries(i18nData.translation || {}).map(([key, value]) => [
            platformHashMap[key] ? platformHashMap[key] : key,
            isString(value) ? value : value.content,
        ])),
    };
}
export const i18nOptions = {
    locale: lang,
    fallbackLocale: fallbackLang,
    messages,
    silentTranslationWarn: true,
    formatter: new CustomFormatter(),
};
Vue.use(VueI18n);
export const i18n = new VueI18n(i18nOptions);
export const $t = (...args) => i18n.t(...args);
// ui-core 使用
window.xy_$t = $t;
Vue.prototype.$t = $t;
function addI18nMessages(locale, messages) {
    i18n.mergeLocaleMessage(locale, messages);
    if (locale === Lang.Chinese && fallbackLang !== Lang.Chinese) {
        i18n.mergeLocaleMessage(fallbackLang, messages);
    }
}
// @ts-ignore
window.addI18nMessages = addI18nMessages;
// 产物使用
window.$t = $t;
export { PLATFORM_LANG_SOURCE };
